import { Link } from 'react-router-dom';
import { MovieItem } from '@/mocks/movies';

interface MovieCardProps {
  movie: MovieItem;
}

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link
      to={`/article/${movie.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 transition-all duration-300 hover:border-primary-300 cursor-pointer"
    >
      <div className="relative overflow-hidden aspect-video">
        <img
          src={movie.image}
          alt={movie.title}
          title={`${movie.title} - 春色影视高清在线观看`}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute top-2 right-2 bg-background-950/80 text-accent-400 text-xs font-semibold px-2 py-1 rounded-md whitespace-nowrap">
          {movie.rating}
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
          <div className="p-3 w-full">
            <div className="flex items-center justify-center gap-1 text-background-50">
              <i className="ri-play-circle-fill text-2xl"></i>
              <span className="text-sm font-medium">立即观看</span>
            </div>
          </div>
        </div>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="text-sm md:text-base font-semibold text-foreground-950 truncate group-hover:text-primary-500 transition-colors">
          {movie.title}
        </h3>
        <div className="flex items-center gap-2 mt-2 text-xs text-foreground-500 flex-wrap">
          <span className="bg-secondary-100 text-secondary-700 px-2 py-0.5 rounded whitespace-nowrap">{movie.category}</span>
          <span>{movie.year}</span>
          <span className="hidden sm:inline">{movie.duration}</span>
        </div>
        <p className="mt-2 text-xs text-foreground-500 line-clamp-2 hidden sm:block">
          {movie.description}
        </p>
      </div>
    </Link>
  );
}